import { render, staticRenderFns } from "./DriversPeriodsUnavailableEditForm.vue?vue&type=template&id=331c73d6&scoped=true&"
import script from "./DriversPeriodsUnavailableEditForm.vue?vue&type=script&lang=js&"
export * from "./DriversPeriodsUnavailableEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversPeriodsUnavailableEditForm.vue?vue&type=style&index=0&id=331c73d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c73d6",
  null
  
)

export default component.exports